module.exports = __webpack_public_path__ + "img/notebook.588d30a1.png";